import React, { useState, useEffect, useRef } from 'react';
import { flushSync } from 'react-dom';
import {
  Row, Col, Typography, Card, Form, Button, message,
  Input,
} from 'antd';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import { getUserMail, getUserType } from '../../../../../utils/users';
import SelectedLands from '../../../serviceComponents/selectedLands/SelectedLands';
import GeoMapSummary from '../../../serviceComponents/geoMapSummary/GeoMapSummary';
import AreaTalhao from '../../../../sharedComponents/talhao/AreaTalhao';
import UploadFiles from '../../../serviceComponents/uploadFiles/UploadFiles';
import { SessionExpiredException } from '../../../../../utils/errors';
import { isItEstimateOrService } from '../../../../../utils/service';
import {
  post, get, isSuperAgentError,
  RequestWrapper, ResponseWrapper,
} from '../../../../../dataSource/requests';
import './Summary.scss';

const Summary = (props): JSX.Element => {
  const [formInstance] = Form.useForm();
  const navigate = useNavigate();
  const userType = getUserType();

  const uploadFilesReference = useRef(null);
  const [valueAttachmentSizeCooperated, setValueAttachmentSizeCooperated] = useState(null);

  const [loading, setLoading] = useState(false);
  const [requestId, setRequestId] = useState(null);

  const titleOrcamento = useRef(false);

  const currencyFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const {
    removeSelectedField, serviceRequestParameters, nextPage, previousPage,
  } = props;

  const userMailCooperative = (): JSX.Element => {
    const targetMail = getUserMail() ? getUserMail()?.replaceAll('"', '') : '-';

    return (
      <div>
        <div>
          <span>{`Email: ${userType === 'COOPERATIVE' ? targetMail : '-'}`}</span>
        </div>
        <div>
          <span style={{ fontSize: '.7rem' }}>(caso esteja incorreto, informar e-mail válido no campo observação)</span>
        </div>
      </div>
    );
  };

  const getLabel = (idCode: string, value): string => {
    switch (idCode) {
      case 'GEOFERT-GRID-TAMANHO_GRID':
        let targetName;

        if (value === 'Outro') {
          targetName = 'Tamanho do grid';
        } else {
          targetName = 'Tamanho do grid (em hectares)';
        }

        return targetName;

      case 'GEOFERT-GRID-GRID_TAMANHO_DESEJADO':
        return 'Tamanho desejado (em hectares)';

      case 'GEOFERT-GRID-V_DESEJADO':
        return 'V% desejado';

      case 'GEOFERT-GRID-PRNT_CALCARIO':
        return 'PRNT do calcário';

      case 'GEOFERT-GRID-PRNT_OXIDO':
        return 'PRNT do óxido';

      case 'GEOFERT-GRID-QUANTAS_PROFUNDIDADES':
        return 'Quantas profundidades?';

      case 'GEOFERT-GRID-VALOR_UNITARIO':
        if (value === '') return '';
        return 'Valor unitário';

      case 'GEOFERT-GRID-VALOR_TOTAL':
        if (value === '') return '';
        return 'Valor total';

      case 'GEOFERT-GRID-CONDICAO_PAGAMENTO':
        if (value === '') return '';
        return 'Condição de pagamento';

      case 'GEOFERT-GRID-FORMA_PAGAMENTO':
        if (value === '') return '';
        return 'Forma de pagamento';

      case 'GEOFERT-GRID-OBSERVACOES':
        if (value === '') return '';
        return 'Observações do orçamento';

      default:
        return '';
    }
  };

  const getField = (idCodeParameter: string): any => {
    return serviceRequestParameters
      .serviceRequestFieldInputList
      .find(
        (field) => {
          return field.idCode === idCodeParameter;
        },
      );
  };

  const printValue = (idCode: string, value): any => {
    switch (true) {
      case (value === true):
      case (value === 'true'):
        return 'Sim';

      case (value === false):
      case (value === 'false'):
        return 'Não';

      case (value?._isAMomentObject):
        return value.format('DD/MM/YYYY');

      case (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(value)):
        return moment(value, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]').format('DD/MM/YYYY');

      case (idCode === 'GEOFERT-GRID-VALOR_UNITARIO' && value !== ''):
        return currencyFormatter.format(value);

      case (idCode === 'GEOFERT-GRID-VALOR_TOTAL' && value !== ''):
        return currencyFormatter.format(value);

      default:
        return value;
    }
  };

  const renderProfundidade = (numeroProfundidade: number): JSX.Element | null => {
    if (numeroProfundidade == null || typeof numeroProfundidade !== 'number') {
      return null;
    }

    const layerIdCode = `GEOFERT-GRID-PROFUNDIDADE_${numeroProfundidade}`;
    const routineIdCode = `GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_${numeroProfundidade}`;
    const routineProportionIdCode = `GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_${numeroProfundidade}_ROTINA_ALUMINIO_ENXOFRE`;
    const microIdCode = `GEOFERT-GRID-MICRO_PROFUNDIDADE_${numeroProfundidade}`;
    const microProportionIdCode = `GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_${numeroProfundidade}_MICRO`;
    const physicalIdCode = `GEOFERT-GRID-FISICA_PROFUNDIDADE_${numeroProfundidade}`;
    const physicalProportionIdCode = `GEOFERT-GRID-PROPORCAO_PRODUNDIDADE_${numeroProfundidade}_FISICA`;
    const layerRangeField = getField(layerIdCode);

    if (layerRangeField == null) {
      return null;
    }

    const routineBooleanField = getField(routineIdCode);
    const microBooleanField = getField(microIdCode);
    const physicalBooleanField = getField(physicalIdCode);

    const routineProportionField = getField(routineProportionIdCode);
    const microProportionField = getField(microProportionIdCode);
    const physicalProportionField = getField(physicalProportionIdCode);

    return (
      <>
        <hr />
        <Row
          className="GridSummary__DetailRow"
        >
          <Col
            className="GridSummary__DetailParentColumn"
            span={24}
          >
            <Row
              className="GridSummary__DetailChildRow"
              justify="space-between"
            >
              <Col
                className="GridSummary__DetailColumn"
              >
                {`Profundidade ${numeroProfundidade}`}
              </Col>
              <Col
                className="GridSummary__DetailSpecificColumn"
              >
                {layerRangeField?.value}
              </Col>
            </Row>
          </Col>
        </Row>

        <Row
          className="GridSummary__DetailRow"
        >
          <Col
            className="GridSummary__DetailParentColumn"
            span={24}
          >
            <Row
              className="GridSummary__DetailChildRow"
              justify="space-between"
            >
              <Col
                className="GridSummary__DetailColumn"
              >
                Rotina, Aluminio e Enxofre
              </Col>
              <Col
                className="GridSummary__DetailSpecificColumn"
              >
                {routineBooleanField?.value === true ? 'Sim' : 'Não'}
              </Col>
            </Row>
          </Col>
        </Row>

        {
          routineBooleanField?.value === true
            ? (
              <Row
                className="GridSummary__DetailRow"
              >
                <Col
                  className="GridSummary__DetailParentColumn"
                  span={24}
                >
                  <Row
                    className="GridSummary__DetailChildRow"
                    justify="space-between"
                  >
                    <Col
                      className="GridSummary__DetailColumn"
                    >
                      Proporção
                    </Col>
                    <Col
                      className="GridSummary__DetailSpecificColumn"
                    >
                      {routineProportionField?.value}
                    </Col>
                  </Row>
                </Col>
              </Row>
            )
            : null
        }

        <Row
          className="GridSummary__DetailRow"
        >
          <Col
            className="GridSummary__DetailParentColumn"
            span={24}
          >
            <Row
              className="GridSummary__DetailChildRow"
              justify="space-between"
            >
              <Col
                className="GridSummary__DetailColumn"
              >
                Micro
              </Col>
              <Col
                className="GridSummary__DetailSpecificColumn"
              >
                {microBooleanField?.value === true ? 'Sim' : 'Não'}
              </Col>
            </Row>
          </Col>
        </Row>

        {
          microBooleanField?.value === true
            ? (
              <Row
                className="GridSummary__DetailRow"
              >
                <Col
                  className="GridSummary__DetailParentColumn"
                  span={24}
                >
                  <Row
                    className="GridSummary__DetailChildRow"
                    justify="space-between"
                  >
                    <Col
                      className="GridSummary__DetailColumn"
                    >
                      Proporção
                    </Col>
                    <Col
                      className="GridSummary__DetailSpecificColumn"
                    >
                      {microProportionField?.value}
                    </Col>
                  </Row>
                </Col>
              </Row>
            )
            : null
        }

        <Row
          className="GridSummary__DetailRow"
        >
          <Col
            className="GridSummary__DetailParentColumn"
            span={24}
          >
            <Row
              justify="space-between"
              className="GridSummary__DetailChildRow"
            >
              <Col
                className="GridSummary__DetailColumn"
              >
                Física
              </Col>
              <Col
                className="GridSummary__DetailSpecificColumn"
              >
                {physicalBooleanField?.value === true ? 'Sim' : 'Não'}
              </Col>
            </Row>
          </Col>
        </Row>

        {
          physicalBooleanField?.value === true
            ? (
              <Row
                className="GridSummary__DetailRow"
              >
                <Col
                  className="GridSummary__DetailParentColumn"
                  span={24}
                >
                  <Row
                    className="GridSummary__DetailChildRow"
                    justify="space-between"
                  >
                    <Col
                      className="GridSummary__DetailColumn"
                    >
                      Proporção
                    </Col>
                    <Col
                      className="GridSummary__DetailSpecificColumn"
                    >
                      {physicalProportionField?.value}
                    </Col>
                  </Row>
                </Col>
              </Row>
            )
            : null
        }
      </>
    );
  };

  const renderField = (idCodeParameter: string): JSX.Element | null => {
    const field = getField(idCodeParameter);

    if (field !== undefined) {
      if (idCodeParameter === 'GEOFERT-GRID-VALOR_UNITARIO' && field.value !== '') {
        titleOrcamento.current = true;
      }

      return (
        <Row
          className="GridSummary__DetailRow"
        >
          <Col
            span={24}
            className="GridSummary__DetailParentColumn"
          >

            {
              idCodeParameter === 'GEOFERT-GRID-VALOR_UNITARIO' && field.value !== ''
              && (
                <>
                  <hr />
                  <p className="GridSummary__SessionTitle">Orçamento</p>
                </>
              )
            }

            {
              titleOrcamento.current === false
              && idCodeParameter === 'GEOFERT-GRID-OBSERVACOES'
              && field.value !== ''
              && (
                <>
                  <hr />
                  <p className="GridSummary__SessionTitle">Orçamento</p>
                </>
              )
            }

            <Row
              justify="space-between"
              className="GridSummary__DetailChildRow"
            >
              <Col
                className="GridSummary__DetailColumn"
              >
                {getLabel(idCodeParameter, field.value)}
              </Col>
              <Col
                className="GridSummary__DetailSpecificColumn"
              >
                {printValue(idCodeParameter, field.value)}
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }

    return null;
  };

  const mask = (rawValue): (string | RegExp)[] => {
    if (rawValue.length > 14) {
      return [
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ];
    }
    return [
      '(',
      /[1-9]/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  };

  const getAttachmentParamenters = async (): Promise<void> => {
    try {
      const requestRef: RequestWrapper = get({
        url: '/system/getAttachmentParamenters',

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      const response = await requestRef;

      setValueAttachmentSizeCooperated(
        response?.body.getAttachmentParamentersOutput.attachmentSizeCooperated,
      );
    } catch (error) {
      message.error('Ocorreu um erro ao buscar informações, tente novamente');
    }
  };

  useEffect(() => {
    getAttachmentParamenters();
    return () => {
      setLoading(false);
    };
  }, []);

  const onFormFinish = async (values): Promise<void> => {
    setLoading(true);
    let response;

    let telValue = values.TelInput;
    telValue = !telValue ? '' : telValue.replace(/\D/g, '');

    const data = {
      landFieldsIds: serviceRequestParameters.talhoesSelecionados.map((v) => v.id),
      landId: serviceRequestParameters.selectedProperty.id,
      landOwnerId: serviceRequestParameters.selectedOwner.id,
      serviceId: serviceRequestParameters.selectedService.id,
      cooperativeNotes: values.observacao,
      telephone: telValue,
      serviceTypeId: serviceRequestParameters.selectedType.id,
      haveCtc: serviceRequestParameters.haveCtc,
      ctc: serviceRequestParameters.ctc,
      branchCoopercitrusId: serviceRequestParameters.branchCoopercitrusId,
    };

    if (userType === 'COOPERATIVE') {
      serviceRequestParameters.serviceRequestFieldInputList.push({
        idCode: 'GEOFERT-GRID-VALOR_UNITARIO',
        value: '',
      });
      serviceRequestParameters.serviceRequestFieldInputList.push({
        idCode: 'GEOFERT-GRID-VALOR_TOTAL',
        value: '',
      });
      serviceRequestParameters.serviceRequestFieldInputList.push({
        idCode: 'GEOFERT-GRID-CONDICAO_PAGAMENTO',
        value: '',
      });
      serviceRequestParameters.serviceRequestFieldInputList.push({
        idCode: 'GEOFERT-GRID-FORMA_PAGAMENTO',
        value: '',
      });
      serviceRequestParameters.serviceRequestFieldInputList.push({
        idCode: 'GEOFERT-GRID-OBSERVACOES',
        value: '',
      });
    }

    let targetUrl = '';
    if (serviceRequestParameters.choiceServiceType === 1) {
      targetUrl = '/budget/requestBudgetService';
      data.budgetRequestFieldInputs = serviceRequestParameters.serviceRequestFieldInputList;
    } else {
      targetUrl = '/service/requestService';
      data.serviceRequestFieldInputList = serviceRequestParameters.serviceRequestFieldInputList;
    }

    try {
      const requestRef: RequestWrapper = post({
        url: targetUrl,
        params: data,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await requestRef;
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        message.error('Ocorreu um erro ao solicitar o serviço, tente novamente');
      }
      setLoading(false);
      return;
    }

    if (!response?.body.error) {
      if (response?.body.code === 5002) {
        flushSync(() => {
          setRequestId(response?.body.createServiceRequestOutput.serviceRequestId);
        });
      } else {
        flushSync(() => {
          setRequestId(response?.body.createBudgetOutput.budgetId);
        });
      }

      const uploadError = !uploadFilesReference.current.validateFiles();
      if (!uploadError) {
        try {
          await uploadFilesReference.current.handleSubmitFiles();
        } catch (error) {
          setLoading(false);
          return;
        }

        nextPage({});
      }
    } else if (response?.body.code === -6006) {
      message.error('Esta cultura não é válida para este serviço');
    } else {
      message.error('Ocorreu um erro ao solicitar o serviço, tente novamente');
    }

    setLoading(false);
  };

  return (
    <div className="GridSummary">
      <Row
        justify="space-between"
        className="GridSummary__TitleRow"
      >
        <Col
          className="GridSummary__TitleCol"
        >
          <Typography.Title
            level={1}
            className="GridSummary__Title"
          >
            Resumo da Solicitação
          </Typography.Title>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="GridSummary__ContentRow"
      >
        <Col
          span={24}
          className="GridSummary__ContentColumn"
        >
          <Card
            className="GridSummary__ContentCard"
          >
            <Form
              scrollToFirstError
              className="GridSummary__Form"
              form={formInstance}
              onFinish={onFormFinish}
              layout="vertical"
              onFinishFailed={
                (errorInfo): void => {
                  console.log('grid summary form finish failed:', errorInfo);
                }
              }
            >
              <Row
                gutter={[24, 24]}
                className="GridSummary__DetailsRow"
              >
                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 12 }}
                  className="GridSummary__DetailsColumn"
                >
                  <Row
                    gutter={[24, 24]}
                    className="GridSummary__ServiceTitleRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="GridSummary__ServiceTitleCol"
                    >
                      <Typography.Title
                        level={1}
                        className="GridSummary__ServiceFullTitle"
                      >
                        <span className="GridSummary__ServiceTitle">{'Geofert: '}</span>
                        <span className="GridSummary__ServicesTypeTitle">Grid</span>
                      </Typography.Title>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="GridSummary__DetailRow GridSummary__MatriculaRow"
                  >
                    <Col
                      className="GridSummary__DetailColumn GridSummary__MatriculaColumn"
                      xs={{ span: 24 }}
                    >
                      {`Matrícula: ${serviceRequestParameters.selectedProperty.matriculation}`}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="GridSummary__DetailRow GridSummary__CooperadoRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="GridSummary__DetailColumn GridSummary__CooperadoColumn"
                    >
                      {`Cooperado: ${serviceRequestParameters.selectedOwner.name}`}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="GridSummary__DetailRow GridSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="GridSummary__DetailColumn GridSummary__PropriedadeColumn"
                    >
                      {`Propriedade: ${serviceRequestParameters.selectedProperty.name}`}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="GridSummary__DetailRow GridSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="GridSummary__DetailColumn GridSummary__PropriedadeColumn"
                    >
                      {
                        userMailCooperative()
                      }
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="GridSummary__DetailRow GridSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="GridSummary__DetailColumn GridSummary__PropriedadeColumn"
                    >
                      <span>{`Possui CTC: ${serviceRequestParameters.haveCtc ? 'Sim' : 'Não'}`}</span>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="GridSummary__DetailRow GridSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="GridSummary__DetailColumn GridSummary__PropriedadeColumn"
                    >
                      <span>{`CTC: ${serviceRequestParameters.ctc ? serviceRequestParameters.ctc : '-'}`}</span>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="GridSummary__DetailRow GridSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="GridSummary__DetailColumn GridSummary__PropriedadeColumn"
                    >
                      <span>{`Filial: ${serviceRequestParameters.branchName ? serviceRequestParameters.branchName : '-'}`}</span>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="GridSummary__DetailsRow GridSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="GridSummary__DetailColumn GridSummary__PropriedadeColumn"
                    >
                      {renderField('GEOFERT-GRID-TAMANHO_GRID')}
                      {renderField('GEOFERT-GRID-GRID_TAMANHO_DESEJADO')}
                      {renderField('GEOFERT-GRID-V_DESEJADO')}
                      {renderField('GEOFERT-GRID-PRNT_CALCARIO')}
                      {renderField('GEOFERT-GRID-PRNT_OXIDO')}
                      {renderField('GEOFERT-GRID-QUANTAS_PROFUNDIDADES')}
                      {renderProfundidade(1)}
                      {renderProfundidade(2)}
                      {renderProfundidade(3)}
                      {renderProfundidade(4)}
                      {renderProfundidade(5)}
                      {renderField('GEOFERT-GRID-VALOR_UNITARIO')}
                      {renderField('GEOFERT-GRID-VALOR_TOTAL')}
                      {renderField('GEOFERT-GRID-CONDICAO_PAGAMENTO')}
                      {renderField('GEOFERT-GRID-FORMA_PAGAMENTO')}
                      {renderField('GEOFERT-GRID-OBSERVACOES')}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="GridSummary__PhoneRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="GridSummary__PhoneColumn"
                    >
                      <Typography.Title
                        level={4}
                        className="GridSummary__PhoneTitle"
                      >
                        Telefone para contato
                      </Typography.Title>
                      <Form.Item
                        name="TelInput"
                        className="GridSummary__PhoneFormItem"
                        validateTrigger={['onBlur']}
                        rules={[
                          {
                            required: true,
                            message: 'Por favor, insira um telefone.',
                          },
                          {
                            min: 14,
                            message: 'Telefone inválido',
                          },
                        ]}
                      >
                        <MaskedInput
                          guide={false}
                          mask={mask}
                          placeholder="Telefone"
                          className="ant-input GridSummary__PhoneMaskedInput"
                          maxLength={15}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="GridSummary__CommentsRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="GridSummary__CommentsColumn"
                    >
                      <Typography.Title
                        level={4}
                        className="GridSummary__CommentsTitle"
                      >
                        Observação
                      </Typography.Title>
                      <Form.Item
                        className="GridSummary__CommentsFormItem"
                        name="observacao"
                        rules={[
                          {
                            max: 1000,
                            message: 'A observação deve ter no máximo 1000 caractéres',
                          },
                        ]}
                      >
                        <Input.TextArea
                          className="obsArea GridSummary__CommentsInput"
                          xs={{ span: 24 }}
                          lg={{ span: 10 }}
                          rows={4}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="GridSummary__AttachmentsRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="GridSummary__AttachmentsColumn"
                    >
                      <Typography.Title
                        level={4}
                        className="GridSummary__AttachmentsTitle"
                      >
                        Anexos do cooperado
                      </Typography.Title>
                      <Form.Item
                        name="anexo"
                        className="GridSummary__AttachmentsFormItem"
                      >
                        <div className="attachments-items-container">
                          <UploadFiles
                            ref={uploadFilesReference}
                            origin="summary"
                            requestType={
                              isItEstimateOrService(
                                serviceRequestParameters.choiceServiceType === 1 ? 'ORCAMENTO' : 'SERVICO',
                                userType,
                              )
                            }
                            typeUser="SERVICE_REQUEST_CUSTOMER_FILE"
                            action="edit"
                            id={requestId}
                            fileSize={valueAttachmentSizeCooperated}
                            initialFiles={
                              [].map((item) => ({ ...item, uid: item.id, status: 'done' }))
                            }
                          />
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 12 }}
                  className="GridSummary__GeomapColumn"
                >
                  <SelectedLands
                    talhoesSelecionados={serviceRequestParameters.talhoesSelecionados}
                    removeSelectedField={removeSelectedField}
                  />

                  <div
                    className="GridSummary__AreaTalhaoSpacing"
                  >
                  </div>

                  <AreaTalhao
                    talhoesSelecionados={serviceRequestParameters.talhoesSelecionados}
                  />

                  <GeoMapSummary
                    params={serviceRequestParameters}
                  />
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
                justify="end"
                className="GridSummary__ButtonRow"
              >
                <Col
                  xs={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                  className="GridSummary__ButtonFirstColumn"
                >
                  <Button
                    block
                    className="GridSummary__BackButton"
                    onClick={
                      (): void => {
                        previousPage();
                      }
                    }
                    loading={loading}
                  >
                    <ArrowLeftIcon className="GridSummary__ArrowLeftIcon" />
                    Voltar
                  </Button>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                  className="GridSummary__ButtonSecondColumn"
                >
                  <Form.Item
                    className="GridSummary__ContinueButtonFormItem"
                  >
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      className="GridSummary__ContinueButton"
                      loading={loading}
                    >
                      Confirmar Solicitação
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Summary.propTypes = {
  removeSelectedField: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,

  serviceRequestParameters: PropTypes.shape({
    haveCtc: PropTypes.bool,
    ctc: PropTypes.string,
    branchCoopercitrusId: PropTypes.number,
    choiceServiceType: PropTypes.number,
    branchName: PropTypes.string,

    serviceTypeDynamicFields: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        idCode: PropTypes.string,
      }),
    ).isRequired,

    serviceSubtypeDynamicFields: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        idCode: PropTypes.string,
      }),
    ).isRequired,

    service: PropTypes.string,

    serviceRequestFieldInputList: PropTypes.arrayOf(
      PropTypes.shape({
        idCode: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
          PropTypes.instanceOf(moment),
          PropTypes.bool,
        ]),
      }),
    ),

    selectedProperty: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
      registeredOn: PropTypes.instanceOf(moment),
      matriculation: PropTypes.string,

      location: PropTypes.shape({
        lat: PropTypes.number,
        lon: PropTypes.number,
      }),
    }),

    selectedType: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),

    selectedService: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),

    selectedOwner: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
    }),

    talhoesSelecionados: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        area: PropTypes.number,
        culture: PropTypes.shape({}),
        details: PropTypes.string,
        landId: PropTypes.number,
        name: PropTypes.string,

        polygon: PropTypes.arrayOf(
          PropTypes.shape({
            lat: PropTypes.number,
            lon: PropTypes.number,
          }),
        ),
      }),
    ),
  }).isRequired,
};
Summary.defaultProps = {};

export default Summary;
